export default __webpack_public_path__ + "static/media/linkedin-icon.299768ea.svg";